
import NotFooterLayout from "layouts/NotFooterLayout";
import CreateShipping from "components/Profiles/SettingShipping/CreateShipping";
 

function CreateShippingPage() {

  return (
    <NotFooterLayout namePage="เพิ่มค่าจัดส่ง" >
      <div className="layout-content">
        <CreateShipping />
      </div>
    </NotFooterLayout>
  );
}

export default CreateShippingPage;